import { render } from "./shopping_list.vue?vue&type=template&id=9d50a918"
import script from "./shopping_list.vue?vue&type=script&lang=js"
export * from "./shopping_list.vue?vue&type=script&lang=js"
script.render = render

export default script